import { environment } from "src/environments/environment";
export const ANALYTICS_DEVICE: { method: string; variant: string; origin?: string; } = { method: environment.isMobile ? 'Nativo' : 'Web', variant: detectDevice() }

function detectDevice(): string {
  const ua = navigator.userAgent;

  const type = /iPad|iPhone|iPod/i.test(ua) ? 'mobile' : /android/i.test(ua) ? 'android' : 'desktop';

  return type;
};
